import { ChangeEvent, FocusEvent } from 'react';
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import { ProjectMappingType } from '../../interfaces/ui/addProjectModal';

interface FormRadioGroupProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  options: readonly ProjectMappingType[];
  error?: string;
  required?: boolean;
  disabled?: boolean;
}

const FormRadioGroup = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  options,
  error,
  required,
  disabled = false,
}: FormRadioGroupProps) => {
  return (
    <Box className="apm-form-group">
      <Typography component="label" className="apm-form-label">
        {label}
        {required && <span className="apm-required">*</span>}
      </Typography>

      <FormControl error={Boolean(error)} component="fieldset">
        <RadioGroup
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          row
          aria-describedby={error ? `${id}-error` : undefined}
          onBlur={onBlur}
        >
          {options.map(option => (
            <FormControlLabel
              key={option}
              value={option}
              control={
                <Radio color="primary" size="small" disabled={disabled} />
              }
              label={
                <Typography className="apm-radio-label" component="span">
                  {option}
                </Typography>
              }
            />
          ))}
        </RadioGroup>

        {error && (
          <FormHelperText className="apm-field-error" id={`${id}-error`}>
            <ErrorRoundedIcon className="apm-field-error-icon" />
            {error}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default FormRadioGroup;
